export default __webpack_public_path__ + "static/media/cars.6fc4c55b.png";